module.exports = __webpack_public_path__ + "img/fantom.5e3db6b3.svg";